module.exports = __webpack_public_path__ + "img/skew.cd856cce.svg";